import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import api from '../../../../../../services/api';
import NavBarGestao from '../../../../../../components/NavBarGestao';

import {
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';

import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import AssessmentIcon from '@mui/icons-material/Assessment';

export default function AuditoriaListagem() {
  const history = useHistory();
  const [auditorias, setAuditorias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  const token = Cookies.get('token');
  const cookieRegra = Cookies.get('regra') ? decodeURIComponent(Cookies.get('regra')) : '';
  const cookieRoot = Cookies.get('ROOT_MASTER') || Cookies.get('root');
  const usuarioLogado = Cookies.get('usuario') ? JSON.parse(Cookies.get('usuario')) : null;

  // Obter id do usuário logado diretamente do cookie id_usuario
  const userId = Cookies.get('id_usuario') || (usuarioLogado ? usuarioLogado.id_usuario || usuarioLogado.id : null);

  // Verifica permissão ROOT_MASTER
  const isRootMaster =
    cookieRegra.includes('ROOT_MASTER') ||
    cookieRegra.includes('ROOT') ||
    !!cookieRoot ||
    (usuarioLogado && (usuarioLogado.root || usuarioLogado.superAdmin || usuarioLogado.perfil === 'ROOT_MASTER'));

  const fetchAuditorias = async () => {
    setLoading(true);
    setErrorMsg('');
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.get('/v1/protected/auditoriamonitoramento/listartodas', { headers });
      setAuditorias(response.data || []);
    } catch (err) {
      console.error('Erro ao carregar auditorias:', err);
      setErrorMsg('Falha ao carregar a lista de auditorias.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAuditorias();
  }, []);

  const handleCriarAuditoria = async () => {
    if (creating) return;
    setCreating(true);
    setErrorMsg('');
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await api.post(`/v1/protected/auditoriamonitoramento/criar/${userId}`, {}, { headers });
      if (response.data && response.data.id_auditoria) {
        history.push(`/tecnica/monitoramento/auditoria/${response.data.id_auditoria}`);
      }
    } catch (err) {
      console.error('Erro ao criar auditoria:', err);
      setErrorMsg('Erro ao gerar nova auditoria automática. Tente novamente.');
      setCreating(false);
    }
  };

  const handleAbrirAuditoria = (id) => {
    history.push(`/tecnica/monitoramento/auditoria/${id}`);
  };

  const handleExcluirAuditoria = async () => {
    if (!confirmDeleteId) return;
    const targetId = confirmDeleteId;
    setConfirmDeleteId(null);
    setDeletingId(targetId);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await api.delete(`/v1/protected/auditoriamonitoramento/excluir/${targetId}/${userId}`, { headers });
      fetchAuditorias();
    } catch (err) {
      console.error('Erro ao excluir auditoria:', err);
      setErrorMsg('Falha ao excluir a auditoria selecionada.');
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div style={{ backgroundColor: '#f4f6f8', minHeight: '100vh', paddingBottom: '40px' }}>
      <NavBarGestao Monitoramento={true} MonitoramentoAuditoria={true} />

      <Container maxWidth="xl" style={{ marginTop: '24px' }}>
        <Paper style={{ padding: '24px', borderRadius: '12px', marginBottom: '24px' }}>
          <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
            <Grid item>
              <Box display="flex" alignItems="center">
                <AssessmentIcon style={{ fontSize: 36, color: '#1976d2', marginRight: 12 }} />
                <div>
                  <Typography variant="h5" style={{ fontWeight: 'bold', color: '#1a237e' }}>
                    Auditorias de Monitoramento
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Gestão e acompanhamento das auditorias internas das localidades monitoradas com PGM.
                  </Typography>
                </div>
              </Box>
            </Grid>
            <Grid item>
              <Box display="flex" gap={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={fetchAuditorias}
                  disabled={loading || creating}
                  startIcon={<RefreshIcon />}
                >
                  Atualizar Lista
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleCriarAuditoria}
                  disabled={loading || creating}
                  startIcon={creating ? <CircularProgress size={20} color="inherit" /> : <AddIcon />}
                  style={{ backgroundColor: '#1976d2', fontWeight: 'bold' }}
                >
                  {creating ? 'Gerando Auditoria...' : 'Cadastrar Nova Auditoria'}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {errorMsg && (
          <Paper style={{ padding: '16px', backgroundColor: '#ffebee', color: '#c62828', marginBottom: '16px' }}>
            <Typography variant="body1">{errorMsg}</Typography>
          </Paper>
        )}

        <Grid container spacing={3} style={{ marginBottom: '24px' }}>
          <Grid item xs={12} sm={4}>
            <Card style={{ borderLeft: '6px solid #1976d2' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Total de Auditorias
                </Typography>
                <Typography variant="h4" style={{ fontWeight: 'bold' }}>
                  {auditorias.length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ borderLeft: '6px solid #ff9800' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Em Andamento
                </Typography>
                <Typography variant="h4" style={{ fontWeight: 'bold', color: '#e65100' }}>
                  {auditorias.filter(a => a.status === 0).length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Card style={{ borderLeft: '6px solid #4caf50' }}>
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Finalizadas
                </Typography>
                <Typography variant="h4" style={{ fontWeight: 'bold', color: '#2e7d32' }}>
                  {auditorias.filter(a => a.status === 1).length}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <TableContainer component={Paper} style={{ borderRadius: '12px', elevation: 3 }}>
          <Table>
            <TableHead style={{ backgroundColor: '#e8eaf6' }}>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>ID</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Título / Descrição</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Data Criação</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Criado Por</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Finalizada Em</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Localidades</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                <TableCell style={{ fontWeight: 'bold' }} align="center">Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" style={{ padding: '32px' }}>
                    <CircularProgress color="primary" />
                    <Typography variant="body2" style={{ marginTop: '8px' }}>
                      Carregando auditorias...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : auditorias.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" style={{ padding: '32px' }}>
                    <Typography variant="body1" color="textSecondary">
                      Nenhuma auditoria cadastrada até o momento.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{ marginTop: '4px' }}>
                      Clique em "Cadastrar Nova Auditoria" para iniciar o relatório automatizado.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                auditorias.map((aud) => (
                  <TableRow key={aud.id_auditoria} hover>
                    <TableCell style={{ fontWeight: 'bold' }}>#{aud.id_auditoria}</TableCell>
                    <TableCell>{aud.titulo}</TableCell>
                    <TableCell>{aud.data_criacao || '-'}</TableCell>
                    <TableCell>{aud.usuario_criador ? aud.usuario_criador.nome_amigavel : '-'}</TableCell>
                    <TableCell>{aud.data_finalizacao || '-'}</TableCell>
                    <TableCell>{aud.itens ? aud.itens.length : 0}</TableCell>
                    <TableCell>
                      {aud.status === 0 ? (
                        <Chip label="Em Andamento" style={{ backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 'bold' }} />
                      ) : (
                        <Chip label="Finalizada" style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' }} />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Box display="flex" justifyContent="center" gap={1}>
                        <Tooltip title={aud.status === 0 ? "Editar Auditoria" : "Visualizar Auditoria"}>
                          <Button
                            variant="contained"
                            size="small"
                            color={aud.status === 0 ? "primary" : "default"}
                            onClick={() => handleAbrirAuditoria(aud.id_auditoria)}
                            startIcon={aud.status === 0 ? <EditIcon /> : <VisibilityIcon />}
                          >
                            {aud.status === 0 ? 'Editar' : 'Visualizar'}
                          </Button>
                        </Tooltip>

                        {isRootMaster && (
                          <Tooltip title="Excluir Auditoria (ROOT_MASTER)">
                            <Button
                              variant="contained"
                              size="small"
                              style={{ backgroundColor: '#d32f2f', color: '#fff' }}
                              onClick={() => setConfirmDeleteId(aud.id_auditoria)}
                              disabled={deletingId === aud.id_auditoria}
                              startIcon={deletingId === aud.id_auditoria ? <CircularProgress size={16} color="inherit" /> : <DeleteIcon />}
                            >
                              Excluir
                            </Button>
                          </Tooltip>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {/* Modal de Confirmação de Exclusão (ROOT_MASTER) */}
      <Dialog open={!!confirmDeleteId} onClose={() => setConfirmDeleteId(null)}>
        <DialogTitle>Excluir Auditoria #{confirmDeleteId}?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Atenção: Esta ação excluirá permanentemente a auditoria e todos os seus itens gravados do banco de dados. Esta operação não pode ser desfeita.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ padding: '16px' }}>
          <Button onClick={() => setConfirmDeleteId(null)} color="default">
            Cancelar
          </Button>
          <Button onClick={handleExcluirAuditoria} variant="contained" style={{ backgroundColor: '#d32f2f', color: '#fff' }}>
            Confirmar Exclusão
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
